import { action, observable, makeObservable } from 'mobx';
import {SuccessResponse, TimeZone, User, userLoaders} from '../../../../domain';
import {Control, HttpPromiseState, newValueForSelection, validators} from '../../../../lib/helpers';

export class UpdateTimeZoneStore {
  @observable.ref
  options: readonly TimeZone[];

  timeZone: Control<TimeZone | null>;

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null = null;

  constructor() {
    makeObservable(this);
    this.timeZone = new Control<TimeZone | null>('', null, validators.required);
    this.options = [];
    this.save = null;
  }

  @action
  init(user: User, timeZones: readonly TimeZone[]) {
    this.options = timeZones;
    this.timeZone.setValue(newValueForSelection(timeZones, user.TimeZone));
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;

    this.timeZone.markTouched();
    if (!this.timeZone.valid)
      return;
    this.save = userLoaders.updateMyTimezone(this.timeZone.value!.Id);
  }
}
